//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import episodeItem from '~/components/content/show/episode.vue';
import dummyItem from '~/components/content/dummy/video_dummy.vue';
import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
export default {
  props: ['show', 'episodes'],
  mixins: [ImageSrcsetMixin],
  components: {
    episodeItem,
    dummyItem,
  },
  computed: {
    ...mapState({
      episode: ({ resourcesStore: {episode} }) => episode,
      loading: ({ resourcesStore: {loading} }) => loading
    }),
  },
};
